module.exports = "/_next/static/images/app-intro-device-velieve@2x-min-ea6f468ff432519c3e4aa1a62b40e116.png.webp";